
import CloseIcon from '../icons/CloseIcon.vue';
import AlertIcon from '~/components/ui/icons/AlertIcon.vue';
import CustomDrawer from '@/components/ui/molecule/CustomDrawer';
export default {
  name: 'PortfolioUnrankInfoModal',
  components: { CustomDrawer, CloseIcon, AlertIcon },
  props: {
    isPublic: {
      type: Boolean,
      default: false,
    },
    itemCountCondition: {
      type: Boolean,
      default: false,
    },
    allocationCondition: {
      type: Boolean,
      default: false,
    },
    lineRuleLimit: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      buttonOptions: {
        PRIVATE: 'private',
        PUBLIC: 'public',
      },
      privacyOptions: {
        // private
        PRIVATE: 'private',
        // public
        UNLISTED: 'unlisted',
        // ranked
        PUBLIC: 'public',
      },
      initialSelectedButtonOption: null,
      selectedButtonOption: null,
      show: false,
    };
  },
  computed: {
    defaultButtonOption() {
      if (this.isPublic) {
        return this.buttonOptions.PUBLIC;
      } else {
        return this.buttonOptions.PRIVATE;
      }
    },
  },
  mounted() {
    this.show = true;
    this.initialSelectedButtonOption = this.defaultButtonOption;
    this.selectedButtonOption = this.defaultButtonOption;
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm');
    },
    handleClose() {
      this.show = false;
      setTimeout(() => {
        this.$emit('close');
      }, 100);
    },
  },
};
